export const RESET = 'GAME_UPDATE_RESET'
export const SET_ERROR = 'GAME_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'GAME_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'GAME_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'GAME_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'GAME_UPDATE_TOGGLE_LOADING'

export const SET_LANGUAGES = 'GAME_UPDATE_SET_LANGUAGES'
export const SET_LANGUAGES_TOGGLE_LOADING = 'GAME_UPDATE_SET_LANGUAGES_TOGGLE_LOADING'

export const SET_BRANDS = 'GAME_UPDATE_SET_BRANDS'
export const SET_BRANDS_TOGGLE_LOADING = 'GAME_UPDATE_SET_BRANDS_TOGGLE_LOADING'

export const SET_TRANSLATION = 'GAME_UPDATE_SET_TRANSLATION'
export const SET_TRANSLATION_TOGGLE_LOADING = 'GAME_UPDATE_SET_TRANSLATION_TOGGLE_LOADING'
export const SET_TRANSLATION_ERROR = 'GAME_UPDATE_SET_TRANSLATION_ERROR'

export const TOGGLE_GAME_FILE_VERSION_LOADING = 'GAME_UPDATE_TOGGLE_GAME_FILE_VERSION_LOADING'
export const GAME_FILE_VERSION_ERROR_SET_VIOLATIONS = 'GAME_UPDATE_GAME_FILE_VERSION_ERROR_SET_VIOLATIONS'
export const GAME_FILE_VERSION_ERROR = 'GAME_UPDATE_GAME_FILE_VERSION_ERROR'
export const SET_GAME_FILE_VERSIONS = 'GAME_UPDATE_SET_GAME_FILE_VERSIONS'
export const SET_GAME_FILE_VERSIONS_VIEW = 'GAME_UPDATE_SET_GAME_FILE_VERSIONS_VIEW'
export const SET_GAME_FILE_VERSIONS_TOTAL_ITEMS = 'GAME_UPDATE_SET_GAME_FILE_VERSIONS_TOTAL_ITEMS'
export const UPLOADED_GAME_FILE_VERSION = 'GAME_UPDATE_UPLOADED_GAME_FILE_VERSION'
export const DELETED_GAME_FILE_VERSION = 'GAME_UPDATE_DELETED_GAME_FILE_VERSION'

export const SET_SELECTED_BRAND_TAB = 'GAME_UPDATE_SET_SELECTED_BRAND_TAB'

export const PUBLISHED_GAME_FILE = 'GAME_UPDATE_PUBLISHED_GAME_FILE'
export const PUBLISH_GAME_FILE_ERROR = 'GAME_UPDATE_PUBLISH_GAME_FILE_ERROR'
export const PUBLISH_GAME_FILE_TOGGLE_LOADING = 'GAME_UPDATE_PUBLISH_GAME_FILE_TOGGLE_LOADING'
